import React, { useEffect, useState } from 'react';
import NavContext from "./NavContext";
import { HeaderBodyMi, HeaderLogo, HeaderOperateur, HeaderServiceMi, HeaderToolsRaccourcis, HeaderNav, HeaderNavList } from "../index";
import HeaderToolsRecherche from "./Tools/HeaderToolsRecherche";
var HeaderMi = function (_a) {
    var children = _a.children;
    var _b = useState(false), hasMenu = _b[0], setHasMenu = _b[1];
    var _c = useState(false), openModaleRecherche = _c[0], setOpenModaleRecherche = _c[1];
    var _d = useState(false), openMenuMobile = _d[0], setOpenMenuMobile = _d[1];
    var toggleMenuMobile = function () {
        setOpenMenuMobile(true);
    };
    useEffect(function () {
        var modalMenu = document.getElementById('modal-menu');
        if (hasMenu && modalMenu) {
            if (openMenuMobile) {
                modalMenu.classList.add('fr-modal--opened');
            }
            else {
                modalMenu.classList.remove('fr-modal--opened');
            }
        }
    }, [openMenuMobile]);
    var headerLogo = null;
    var headerOperateur = null;
    var headerService = null;
    var headerToolsRaccourcis = null;
    var headerToolsRecherche = null;
    var navList = null;
    var recupererElement = function (child) {
        switch (child.type) {
            case HeaderLogo:
                headerLogo = child;
                break;
            case HeaderOperateur:
                headerOperateur = child;
                break;
            case HeaderServiceMi:
                headerService = child;
                break;
            case HeaderToolsRaccourcis:
                headerToolsRaccourcis = child;
                break;
            case HeaderToolsRecherche:
                headerToolsRecherche = child;
                break;
            case HeaderNavList:
                navList = child;
                break;
        }
    };
    if (Array.isArray(children)) {
        children.forEach(function (child) {
            recupererElement(child);
        });
    }
    else {
        recupererElement(children);
    }
    return (React.createElement(NavContext.Provider, { value: {
            hasMenu: hasMenu,
            setHasMenu: setHasMenu,
            openMenuMobile: openMenuMobile,
            setOpenMenuMobile: setOpenMenuMobile,
            openModaleRecherche: openModaleRecherche,
            setOpenModaleRecherche: setOpenModaleRecherche
        } },
        React.createElement("header", { role: "banner", className: "fr-header dsmi-header" },
            React.createElement(HeaderBodyMi, null,
                React.createElement("div", { className: "fr-header__brand fr-enlarge-link" },
                    React.createElement("div", { className: "fr-header__brand-top" },
                        headerLogo ? (headerLogo) : null,
                        headerOperateur ? (headerOperateur) : null,
                        hasMenu || headerToolsRecherche ? (React.createElement("div", { className: "fr-header__navbar" },
                            headerToolsRecherche ? (React.createElement("button", { className: "fr-btn--search fr-btn", "data-fr-opened": openModaleRecherche, "aria-controls": "modal-bouton-recherche", title: "Rechercher", onClick: function () { return setOpenModaleRecherche(true); } }, "Rechercher")) : null,
                            hasMenu ? (React.createElement("button", { className: "fr-btn--menu fr-btn", "data-fr-opened": openMenuMobile, "aria-controls": "modal-menu", "aria-haspopup": "menu", id: "button-menu-mobile", title: "Menu", onClick: toggleMenuMobile }, "Menu")) : null)) : null),
                    headerService ? (headerService) : null),
                React.createElement(React.Fragment, null, headerToolsRaccourcis || headerToolsRecherche ? (React.createElement("div", { className: "fr-header__tools" },
                    headerToolsRaccourcis ? (React.createElement("div", { className: "fr-header__tools-links" }, headerToolsRaccourcis)) : null,
                    headerToolsRecherche ? headerToolsRecherche : null)) : null)),
            headerToolsRaccourcis || navList ? (React.createElement(HeaderNav, null,
                React.createElement(React.Fragment, null,
                    headerToolsRaccourcis ? (React.createElement("div", { className: "fr-header__menu-links" }, headerToolsRaccourcis)) : null,
                    navList ? (React.createElement("nav", { className: "fr-nav", id: "navigation-header", role: "navigation", "aria-label": "Menu principal" }, navList)) : null))) : null)));
};
export default HeaderMi;
